import { fontSizes, fontWeights } from "@dana/MobiusOverrides/styles/typography";
import { productCarouselProductCondensedStyles } from "@dana/Overrides/Components/ProductCarouselProductCondensed";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";

productCarouselProductCondensedStyles.productPartNumbersStyles = mergeToNew(productCarouselProductCondensedStyles.productPartNumbersStyles, {
  erpNumberValueText: {
    size: fontSizes.small,
    weight: fontWeights.semiBold
  }
});